import { render, staticRenderFns } from "./elevatorMonitor.vue?vue&type=template&id=1c5134d9&scoped=true&"
import script from "./elevatorMonitor.vue?vue&type=script&lang=js&"
export * from "./elevatorMonitor.vue?vue&type=script&lang=js&"
import style0 from "./elevatorMonitor.vue?vue&type=style&index=0&id=1c5134d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5134d9",
  null
  
)

export default component.exports